export const UUID = 'uuid';
export const IS_TASK_SELECTION_MODE = 'isTasksSelectionMode';
export const SELECTED_TASK = 'selectedTasks';
export const CURRENT_USER = 'currentUser';
